interface Config {
  apiBaseUrl: string;
  uiBaseUrl: string;
  environment: string;
}

const devConfig: Config = {
  apiBaseUrl: 'http://localhost:3001/api',
  uiBaseUrl: 'http://localhost:3000',
  environment: 'development',
};

const prodConfig: Config = {
  apiBaseUrl: 'https://sysmonitor.meetingstech.com/api',
  uiBaseUrl: 'https://sysmonitor.meetingstech.com',
  environment: 'production',
};

const config = process.env.NODE_ENV == 'production' ? prodConfig : devConfig;

console.log('NODE_ENV:', process.env.NODE_ENV);

export default config;
